export default "__VITE_ASSET__pZPpJTnw__"